const TOKEN = 'GTPROJECT-TOKEN';
const AUTH_MODE = 'GTPROJECT-AUTH-MODE';

export default {
    key: TOKEN,

    /**
     * Verifica se esta usando autenticacao via cookie (SPA mode).
     * Quando auth_mode == 'session', o cookie httpOnly e gerenciado pelo browser.
     */
    isSessionMode() {
        return sessionStorage.getItem(AUTH_MODE) === 'session';
    },

    /**
     * Retorna o token se estiver em modo Bearer.
     * Em modo session, retorna null (cookie httpOnly nao e acessivel via JS).
     */
    get() {
        if (this.isSessionMode()) {
            return sessionStorage.getItem(AUTH_MODE); // retorna 'session' como truthy
        }
        return sessionStorage.getItem(TOKEN);
    },

    /**
     * Verifica se o usuario esta autenticado (qualquer modo).
     */
    isAuthenticated() {
        return this.isSessionMode() || !!sessionStorage.getItem(TOKEN);
    },

    /**
     * Retorna headers de Authorization.
     * Em modo session: retorna objeto vazio (cookie e enviado automaticamente via withCredentials).
     * Em modo token: retorna header Bearer.
     */
    getHeader() {
        if (this.isSessionMode()) {
            return {};
        }
        let token = sessionStorage.getItem(TOKEN);
        if (!token) {
            return {};
        }
        return {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
    },

    /**
     * Remove credenciais armazenadas (ambos os modos).
     */
    remove() {
        sessionStorage.removeItem(TOKEN);
        sessionStorage.removeItem(AUTH_MODE);
    },

    /**
     * Armazena token Bearer (modo API).
     */
    set(token) {
        sessionStorage.removeItem(AUTH_MODE);
        if (sessionStorage.getItem(TOKEN)) {
            sessionStorage.removeItem(TOKEN);
        }
        sessionStorage.setItem(TOKEN, token);
    },

    /**
     * Marca que estamos usando autenticacao via session/cookie (modo SPA).
     * Nenhum token e armazenado - o cookie httpOnly e gerenciado pelo browser.
     */
    setSessionMode() {
        sessionStorage.removeItem(TOKEN);
        sessionStorage.setItem(AUTH_MODE, 'session');
    },
}
